/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Start_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Chain to Previous Event" |
*
* @param {Snap_To_Start_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_start_aria_label = /** @type {((inputs?: Snap_To_Start_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Start_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enchainer a l'Evenement Precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindung zum vorherigen Ereignis herstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Concatena all'evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цепочка к предыдущему событию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cadena al evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("链至上一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のイベントへのチェーン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछली घटना से जुड़ी कड़ी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Encadeamento ao evento anterior")
	return /** @type {LocalizedString} */ ("Chain to Previous Event")
});